import React from "react";
import { Link } from "react-router-dom";
import ScrollToTop from "../../../common/ScrollToTop";
import portals from "../../../data/portals.json";
import UnlockedPortalNav from "./UnlockedPortalNav";
import Button from "../../../common/Elements/Button";
import CountdownClock from "../../CountdownClock";
import PropTypes from "prop-types";
import { awsUrl, triggerGAEvent } from "../../../helpers";
import Footer from "../../Footer";
import { useUserContext } from "../../../context/UserContext";
import { useZoomDetector } from "../../../hooks/useZoomDetector";

const UnlockedPortalWrapper = ({ children, bgColorClass, gaPrefix }) => {
  const { currentPortal } = useUserContext();
  const { zoomStyles } = useZoomDetector();

  const nextPortal = portals
    .filter((portal, idx) => {
      return new Date(portal.release_timestamp) > Date.now() && portal.key !== "welcome";
    })
    .map((portal) => {
      return [{ name: portal.name, timestamp: portal.release_timestamp, key: portal.key }];
    })
    .sort((a, b) => a.release_timestamp - b.release_timestamp);

  return (
    <div className={bgColorClass + ` ` + zoomStyles}>
      <ScrollToTop />
      <UnlockedPortalNav bgColorClass={bgColorClass} gaPrefix={gaPrefix} />
      {children}
      <div className=" bg-[#E3F2FA] px-[22px] py-16 lg:py-0 lg:h-[206px] flex items-center">
        {currentPortal.key === "retail" && (
          <div className="grid lg:grid-cols-2 max-w-[970px] mx-auto">
            {" "}
            <div className="uppercase text-[18px] font-bold text-center flex border-b md:border-b-0 md:border-r border-dark-blue pb-[20px] md:pb-0 mx-auto lg:mx-0">
              <img
                src={`${awsUrl}/media/portals/${nextPortal[0][0].key}/icon.svg`}
                alt="icon"
                className="inline-block flex-none w-[72px] md:w-[104px] mr-2 md:mr-5 hidden"
                aria-hidden="true"
              />
              <div className="text-[15px] leading-[20px] md:text-[18px] md:leading-[24px] flex flex-col justify-center">
                <span className="block ">Check back soon. </span>The retail portal unlocks in:
                <CountdownClock date={nextPortal[0][0].timestamp} theme={`dark`} />
              </div>
            </div>
            <div className="text-center pt-[20px] md:pt-0 lg:pl-28">
              <p className="text-[30px] leading-[35px] mb-5 ">
                Don’t miss your chance to win a cruise to paradise
              </p>
              <Link
                to={"/#sweeps"}
                className="font-semibold"
                onClick={() => {
                  triggerGAEvent(`${gaPrefix}_sweepstakes`);
                }}
              >
                <Button theme="dark" className={`bg-[#FEBD40] px-20 lg:px-24`}>
                  Enter now
                </Button>
              </Link>
            </div>
          </div>
        )}
        {currentPortal.key === "family-friendly" && (
          <div className="grid lg:grid-cols-2 max-w-[970px] mx-auto">
            {" "}
            <div className="uppercase text-[18px] font-bold text-center flex border-b md:border-b-0 md:border-r border-dark-blue pb-[20px] md:pb-0 mx-auto lg:mx-0">
              <img
                src={`${awsUrl}/media/portals/${nextPortal[0][0].key}/icon.svg`}
                alt="icon"
                className="inline-block flex-none w-[72px] md:w-[104px] mr-2 md:mr-5 "
                aria-hidden="true"
              />
              <div className="text-[15px] leading-[20px] md:text-[18px] md:leading-[24px] flex flex-col justify-center">
                <span className="block ">Check back soon. </span>The family portal unlocks in:
                <CountdownClock date={nextPortal[0][0].timestamp} theme={`dark`} />
              </div>
            </div>
            <div className="text-center pt-[20px] md:pt-0 lg:pl-28">
              <p className="text-[30px] leading-[35px] mb-5 ">
                Don’t miss your chance to win a cruise to paradise
              </p>
              <Link
                to={"/#sweeps"}
                className="font-semibold"
                onClick={() => {
                  triggerGAEvent(`${gaPrefix}_sweepstakes`);
                }}
              >
                <Button theme="light" className={`bg-[#6270C6] px-20 lg:px-24`}>
                  Enter now
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

UnlockedPortalWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  bgColorClass: PropTypes.string.isRequired
};

export default UnlockedPortalWrapper;
